/**
 * @license Givaudan. All rights reserved
 * @author Ayoub MHAMDI
 */

import { TagCategory } from '../models/article/tag-category.model';
import { TagCategoryResponse } from '../models/article/tag-category-response.model';

export function TagsCategoryDto(
  response: TagCategoryResponse[]
): TagCategory[] {
  const groupedTags: TagCategory[] = [];

  response.forEach(tag => {
    const categoryId = tag.data.category.value.id;
    const categoryName = tag.data.category.value.name;

    const existingGroup = groupedTags.find(group => group.id === categoryId);
    if (!existingGroup) {
      groupedTags.push({ id: categoryId, name: categoryName, tags: [] });
    }

    const index = groupedTags.findIndex(group => group.id === categoryId);
    groupedTags[index].tags.push({
      id: tag.id,
      name: tag.name,
      label: tag.data.label,
    });
  });

  return groupedTags;
}
